import { httpClient, type ID, createBatcher, type Batcher, type Cursor } from '#shared'
import type { GetMessagePositionsResponse } from '../model/get-message-positions-response'

async function getMessagePositions(chatId: ID, messageIds: ID[]) {
  const searchParams = new URLSearchParams()
  for (const messageId of messageIds) {
    searchParams.append('messageIds[]', messageId.toString())
  }

  const response = await httpClient.get<GetMessagePositionsResponse>(
    `chats/${chatId}/messages/positions?${searchParams.toString()}`
  )

  const parsedResponse = await response.json()
  return parsedResponse.data
}

const batchersByChatId = new Map<ID, Batcher<[messageId: ID], Cursor>>()
function createBatcherForChat(chatId: ID) {
  return createBatcher(async (calls: [messageId: ID][]) => {
    const parsedResponse = await getMessagePositions(chatId, calls.flat())
    const result = calls.map(([messageId]) => parsedResponse[messageId])
    return result
  })
}

export function getMessagePosition(chatId: ID, messageId: ID) {
  if (!batchersByChatId.has(chatId)) {
    batchersByChatId.set(chatId, createBatcherForChat(chatId))
  }

  const batcher = batchersByChatId.get(chatId)!
  return batcher.run(messageId)
}
